<template>
  <div v-if="filtros != null">
    <v-dialog v-model="openLatBus" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="red darken-4">
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="openLatBus = false"><v-icon>close</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs10>
            <FiltroHoteles />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import FiltroHoteles from "@/components/hoteles/FiltroHoteles.vue"
export default {
  name: "buscadorLateral",
  components: {
    FiltroHoteles
  },
  mounted() {
    //   this.$router.push({name: 'cuposAereos'});
  },
  beforeCreate() {},
  methods: {},
  beforeRouteEnter(to, from, next) {},
  computed: {
    openLatBus: {
      get() {
        return this.$store.getters["app/getOpenLatBus"]
      },
      set(value) {
        this.$store.dispatch("app/setLatBus", value)
      }
    },
    filtros: {
      get() {
        return this.$store.getters["filtroHoteles/getFiltros"]
      },
      set(value) {
        this.$store.commit("filtroHoteles/mutFiltro", value)
        //this.$store.dispatch("filtroHoteles/mutFiltro", value);
      }
    }
  }
}
</script>
